module.exports = __webpack_public_path__ + "static/media/logo.68359820.svg";